import { termsOfService } from '../data/content';
import usePageMeta from '../hooks/usePageMeta';

export default function Terms() {
  usePageMeta({
    title: 'Norppa - Käyttöehdot',
    description: 'Norppa-sovelluksen käyttöehdot. Tutustu palvelun ehtoihin ennen käyttöä.',
    canonical: 'https://pulmakivi.fi/kayttoehdot',
  });

  return (
    <div>
      <h1 className="page__title">Käyttöehdot</h1>
      <p className="legal-updated">Päivitetty: {termsOfService.lastUpdated}</p>

      {termsOfService.sections.map((section, i) => (
        <section key={i} className="legal-section">
          <h2>{section.title}</h2>
          <p>{section.content}</p>
        </section>
      ))}
    </div>
  );
}
